import { render, staticRenderFns } from "./ResearchInfoCards.vue?vue&type=template&id=0145d67c"
import script from "./ResearchInfoCards.vue?vue&type=script&lang=js"
export * from "./ResearchInfoCards.vue?vue&type=script&lang=js"
import style0 from "./ResearchInfoCards.vue?vue&type=style&index=0&id=0145d67c&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0145d67c')) {
      api.createRecord('0145d67c', component.options)
    } else {
      api.reload('0145d67c', component.options)
    }
    module.hot.accept("./ResearchInfoCards.vue?vue&type=template&id=0145d67c", function () {
      api.rerender('0145d67c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchInfoCards.vue"
export default component.exports